import React, { lazy, Suspense } from "react";
import type { FormikProps } from "formik";
import { useTranslation } from "react-i18next";

import type { SilaeFormData } from "@/types/silae";
import type { CodeMeta } from "../validation-diagram/utils/buildGraph";

export type { CodeMeta };

const ValidationGraph = lazy(
  () => import("../validation-diagram/ValidationGraph"),
);

interface Step5ValidationProps {
  formik: FormikProps<SilaeFormData>;
  codeMeta?: CodeMeta | null;
  codeId?: string | null;
}

export const Step5Validation: React.FC<Step5ValidationProps> = ({
  formik,
  codeMeta,
  codeId,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2 mb-8">
        <h3 className="text-xl font-semibold">{t("step5Validation.title")}</h3>
        <p className="text-muted-foreground">{t("step5Validation.subtitle")}</p>
      </div>

      <Suspense
        fallback={
          <div className="w-full h-[70vh] min-h-[500px] rounded-lg border border-neutral-200 dark:border-neutral-700 bg-muted/30 flex items-center justify-center text-sm text-muted-foreground">
            Chargement du diagramme…
          </div>
        }
      >
        <ValidationGraph
          data={formik.values}
          codeMeta={codeMeta}
          codeId={codeId ?? null}
        />
      </Suspense>
    </div>
  );
};
